export default "<p>msg-dialog works!</p>\n"